import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { useLocation } from "react-router-dom";
import FadeOnScreen from "../../utils/fadeOnScreen";
import localData from "../../localData";
import { Button } from "../../components";
import Validation from "../../utils/validation";

export default function Contact() {
    const { sendEmail } = useGlobalContext();
    const { fade } = useGlobalContext().animations;

    const location = useLocation();

    const { contactIcon, contactUs } = localData.images;

    useEffect(() => FadeOnScreen.createObserver(), [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
        Validation.init();
    }, []);

    // SUBMIT
    const { createAlert } = useGlobalContext();

    const form = useRef(null);

    //
    return (
        <motion.main {...fade} className="contact-page">
            <section className="showcase" data-lazy-block>
                <div className="container">
                    <div className="showcase-icon">
                        <img src={contactIcon} alt="" />
                    </div>
                    <h2 className="showcase-title display-1">
                        <span className="showcase-question">
                            {" "}
                            What keeps you up at night? <span className="fill">What keeps you up at night?</span>
                        </span>

                        <span className="showcase-answer " data-lazy="fade" data-lazy-delay="2000">
                            talk to us
                        </span>
                    </h2>
                </div>
            </section>

            <section className="contact" data-lazy-block>
                <div className="container">
                    <div className="contact-center">
                        <div className="contact-cover" data-lazy="fade-up">
                            <img src={contactUs} alt="" />
                        </div>
                        <form
                            className="form contact-form needs-validation"
                            noValidate
                            ref={form}
                            onSubmit={(e) => sendEmail(form,e)}
                        >
                            <div className="form-inner">
                                <h2 className="contact-title display-3">
                                    What keeps you up at night?
                                    <br /> Talk to us
                                </h2>
                                <h6 className="contact-subtitle">Speak to an expert today</h6>
                                <div className="input-group">
                                    <input type="text" className="form-control" required name="from_name" placeholder=" " />
                                    <label className="form-label">name</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">name is required.</div>
                                </div>
                                <div className="input-group">
                                    <input type="email" required className="form-control" name="from_email" placeholder=" " />
                                    <label className="form-label">email</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">email is required.</div>
                                </div>
                                <div className="input-group">
                                    <input type="text" className="form-control" name="from_telephone" placeholder=" " />
                                    <label className="form-label">telephone</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">telephone is required.</div>
                                </div>
                                <div className="input-group">
                                    <textarea  id="" cols="30" rows="3" required name="from_message" className="form-control" placeholder=" "></textarea>
                                    <label className="form-label">message</label>
                                    <div className="form-border"></div>
                                    <div className="valid-feedback">looks good.</div>
                                    <div className="invalid-feedback">message is required.</div>
                                </div>

                                <input type="text" name="to_name" defaultValue="Funmi" style={{ display: "none" }} />
                                <input
                                    type="text"
                                    name="text"
                                    defaultValue="You got a new message from"
                                    style={{ display: "none" }}
                                />

                                <button type="submit" className="btn btn-xl btn-danger">
                                    <span>Submit</span>
                                </button>
                                <p>or</p>
                                <div className="form-links">
                                    <a href="tel:08085370831" className="link-primary" underline="hover">
                                        08085370831
                                    </a>
                                    <a
                                        href="mailto:mowidadigital@gmail.com"
                                        className="link-primary"
                                        underline="hover"
                                        target="_blank"
                                    >
                                        mowidadigital@gmail.com
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
